<template>
  <engagements-dashboard
    :selectedDate="selectedDate"
    :selectedPeriod="selectedPeriod"
    :selectedFilter="selectedFilter"
    :chartsData="chartsData"
    :mainChartData="mainChartData"
    @previous="handlePrevious($event)"
    @next="handleNext($event)"
    @changePeriod="handleChangePeriod($event)"
    @changeFilter="handleChangeFilter($event)"
    @changeDate="handleChangeDate($event)">
  </engagements-dashboard>
</template>

<script>
import { mapState } from 'vuex';

import EngagementsDashboard from '@/components/analytics/EngagementsDashboard';

import * as analyticsTypes from '@/store/modules/analytics/mutation-types';

export default {
  name: 'EngagementsContainer',
  components: {
    EngagementsDashboard,
  },
  computed: {
    ...mapState('analytics', [
      'selectedDate',
      'selectedPeriod',
      'selectedFilter',
      'chartsData',
      'mainChartData',
    ]),
  },
  mounted() {
    this.$store.commit(`analytics/${analyticsTypes.SET_ANALYTICS_TIMESLOT}`, { timeslot: 0 });
    this.loadCharts();
  },
  methods: {
    loadCharts() {
      this.$store.dispatch('analytics/getCharts');
      this.$store.dispatch('analytics/getMainChart');
    },
    handlePrevious(event) {
      this.$store.commit(`analytics/${analyticsTypes.SUBTRACT_ANALYTICS_DATE}`, {
        period: event.unit,
        amount: 1,
      });
      this.loadCharts();
    },
    handleNext(event) {
      this.$store.commit(`analytics/${analyticsTypes.ADD_ANALYTICS_DATE}`, {
        period: event.unit,
        amount: 1,
      });
      this.loadCharts();
    },
    handleChangePeriod(event) {
      if (this.selectedPeriod === event.unit) return;
      this.$store.commit(`analytics/${analyticsTypes.SET_ANALYTICS_PERIOD}`, {
        period: event.unit,
      });
      this.loadCharts();
    },
    handleChangeFilter(event) {
      if (this.selectedFilter === event.filter) return;
      this.$store.commit(`analytics/${analyticsTypes.SET_ANALYTICS_FILTER}`, {
        filter: event.filter,
      });
      this.$store.dispatch('analytics/getMainChart');
    },
    handleChangeDate(event) {
      this.$store.commit(`analytics/${analyticsTypes.SET_ANALYTICS_DATE}`, { date: event.date });
      this.$store.commit(`analytics/${analyticsTypes.SET_ANALYTICS_PERIOD}`, {
        period: event.period,
      });
      this.loadCharts();
    },
  },
};
</script>



// WEBPACK FOOTER //
// EngagementsContainer.vue?0c4877a0